module.exports = __webpack_public_path__ + "static/img/1.817d7b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/11/1.png
// module id = Z7cy
// module chunks = 0